/**
 * Ruta raíz del router. Decide entre layout autenticado y página de login.
 */
import { Outlet, createRootRoute, useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import { useAuth } from '@/features/auth/AuthProvider';

function RootComponent() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (isLoading) return;
    if (!user && path !== '/login') {
      navigate({ to: '/login', search: { redirect: path } });
    } else if (user && path === '/login') {
      navigate({ to: '/' });
    }
  }, [user, isLoading, path, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="kb-skeleton h-8 w-8 rounded-full" />
      </div>
    );
  }

  if (!user) return <Outlet />;
  return <AppLayout />;
}

export const Route = createRootRoute({ component: RootComponent });
